<a nz-dropdown
   nzTrigger="click"
   [(nzVisible)]="dropdownVisibility"
   [nzDropdownMenu]="content">
  <rappider-icon [name]="filterIconConfig.name"
                 [color]="isFilterApplied ? 'var(--primary-color)' : 'var(--text-color)'"
                 (click)="toggleDropdown($event)"></rappider-icon>
</a>

<nz-dropdown-menu #content="nzDropdownMenu">
  <div class="filterDropdown">
    <div *ngIf="value"
         class="filter-container">
      <ng-container
                    *ngIf="columnType === CrudViewColumnType.Number || columnType === CrudViewColumnType.Currency || columnType === CrudViewColumnType.Rate">
        <div class="wrapper">
          <nz-collapse nzGhost="true">
            <nz-collapse-panel nzHeader="Filter by condition"
                               [nzActive]="isConditionPanelActive">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-select [(ngModel)]="value.condition"
                                   [options]="numberConditions"
                                   placeholder="Select Condition"></rappider-select>
                </div>
              </div>
            </nz-collapse-panel>
            <nz-collapse-panel nzHeader="Filter by value"
                               [nzActive]="isValuePanelActive">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-number-input [(ngModel)]="value.filterValue"></rappider-number-input>
                </div>
                <div class="remove-filter-icon"
                     *ngIf="shouldShowValueRemoveIcon()">
                  <rappider-button [type]="removeFilterButtonConfig.type"
                                   [icon]="removeFilterButtonConfig.icon"
                                   (click)="removeFilterValue()">
                  </rappider-button>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      </ng-container>
      <ng-container *ngIf="columnType === CrudViewColumnType.Text ||
    columnType === CrudViewColumnType.Link || columnType === CrudViewColumnType.Tag ||
    columnType === CrudViewColumnType.TagList || columnType === CrudViewColumnType.Icon ||
    columnType === CrudViewColumnType.Image || columnType === CrudViewColumnType.ActionLink ||
    columnType === CrudViewColumnType.Code || columnType === CrudViewColumnType.InputTemplate ||
    !isTypeSupportedForFilter()">
        <div class="wrapper">
          <nz-collapse nzGhost="true">
            <nz-collapse-panel nzHeader="Filter by condition"
                               [nzActive]="isConditionPanelActive">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-select [(ngModel)]="value.condition"
                                   [options]="stringConditions"
                                   placeholder="Select Condition"></rappider-select>
                </div>
              </div>
            </nz-collapse-panel>
            <nz-collapse-panel nzHeader="Filter by value"
                               [nzActive]="isValuePanelActive">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-textbox [(ngModel)]="value.filterValue"
                                    placeholder="Search"></rappider-textbox>
                </div>
                <div class="remove-filter-icon"
                     *ngIf="shouldShowValueRemoveIcon()">
                  <rappider-button [type]="removeFilterButtonConfig.type"
                                   [icon]="removeFilterButtonConfig.icon"
                                   (click)="removeFilterValue()">
                  </rappider-button>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      </ng-container>
      <ng-container *ngIf="columnType === CrudViewColumnType.Boolean">
        <div class="wrapper">
          <nz-collapse nzGhost="true">
            <nz-collapse-panel nzHeader="Filter by condition"
                               [nzActive]="isConditionPanelActive">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-radio-group [(ngModel)]="value.condition"
                                        [options]="booleanConditions"></rappider-radio-group>
                </div>
              </div>
            </nz-collapse-panel>
            <nz-collapse-panel nzHeader="Filter by value"
                               [nzActive]="isValuePanelActive">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-radio-group [(ngModel)]="value.condition"
                                        [options]="booleanValueOptions"></rappider-radio-group>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      </ng-container>
      <ng-container *ngIf="columnType === CrudViewColumnType.Date">
        <div class="wrapper">
          <nz-collapse nzGhost="true">
            <nz-collapse-panel nzHeader="Filter by condition"
                               [nzActive]="isConditionPanelActive">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-select [(ngModel)]="value.condition"
                                   placeholder="Search Condition"
                                   [options]="dateConditions"></rappider-select>
                </div>
              </div>
            </nz-collapse-panel>
            <nz-collapse-panel nzHeader="Filter by value"
                               [nzActive]="activeTab"
                               (nzActiveChange)="changeActiveTabStatus()">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-date-picker *ngIf="activeTab"
                                        [(ngModel)]="value.filterValue"
                                        [dateFormat]="'MM-DD-YYYY'"
                                        [showTime]="false"></rappider-date-picker>
                </div>
                <div class="remove-filter-icon"
                     *ngIf="shouldShowValueRemoveIcon()">
                  <rappider-button [type]="removeFilterButtonConfig.type"
                                   [icon]="removeFilterButtonConfig.icon"
                                   (click)="removeFilterValue()">
                  </rappider-button>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      </ng-container>
      <ng-container *ngIf="columnType === CrudViewColumnType.DateTime">
        <div class="wrapper">
          <nz-collapse nzGhost="true">
            <nz-collapse-panel nzHeader="Filter by condition"
                               [nzActive]="isConditionPanelActive">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-select [(ngModel)]="value.condition"
                                   placeholder="Search Condition"
                                   [options]="dateConditions"></rappider-select>
                </div>
              </div>
            </nz-collapse-panel>
            <nz-collapse-panel nzHeader="Filter by value"
                               [nzActive]="activeTab"
                               (nzActiveChange)="changeActiveTabStatus()">
              <div class="filter-wrapper">
                <div class="input">
                  <rappider-date-picker *ngIf="activeTab"
                                        [(ngModel)]="value.filterValue"
                                        [dateFormat]="'MM/dd/yyyy'"
                                        [showTime]="true"></rappider-date-picker>
                </div>
                <div class="remove-filter-icon"
                     *ngIf="shouldShowValueRemoveIcon()">
                  <rappider-button [type]="removeFilterButtonConfig.type"
                                   [icon]="removeFilterButtonConfig.icon"
                                   (click)="removeFilterValue()">
                  </rappider-button>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      </ng-container>
      <ng-container>
        <div class="remove-filter-button">
          <a nz-button
             nzType="link"
             nzDanger
             (click)="removeFilter()">
            Clear all
          </a>
        </div>
      </ng-container>
      <div class="filter-footer">
        <rappider-divider></rappider-divider>
        <div class="footer-buttons">
          <rappider-button [text]="cancelButtonConfig.text"
                           [type]="cancelButtonConfig.type"
                           [size]="cancelButtonConfig.size"
                           (click)="cancelFilter()"></rappider-button>
          <rappider-button [text]="OkButtonConfig.text"
                           [type]="OkButtonConfig.type"
                           [size]="OkButtonConfig.size"
                           (click)="applyFilter()"></rappider-button>
        </div>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
